module.exports = __webpack_public_path__ + "img/Bell_active.67683fc2.svg";